/**
 * Shared IntersectionObserver reveal utility.
 * Elements with [data-reveal] get .is-revealed once in view (fired once).
 * Per-use config via data attributes — thresholds/rootMargins are ported
 * verbatim from each source component when sections adopt this:
 *   data-reveal-threshold="0.1"    (default 0.1)
 *   data-reveal-margin="0px"       (rootMargin, default 0px)
 */
(function () {
  'use strict';

  function observe(el) {
    if (el.dataset.revealInit) return;
    el.dataset.revealInit = '1';

    var threshold = parseFloat(el.getAttribute('data-reveal-threshold') || '0.1');
    var margin = el.getAttribute('data-reveal-margin') || '0px';

    var observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) {
          el.classList.add('is-revealed');
          observer.disconnect();
        }
      },
      { threshold: threshold, rootMargin: margin }
    );
    observer.observe(el);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-reveal]').forEach(observe);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  window.Dylys = window.Dylys || {};
  window.Dylys.initReveals = initAll;
})();
